import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { Reference } from '@apollo/client';
import _ from 'lodash';



export const Address: ITypeSpecificPolicy<types.Address> = {

  fields: {
    formattedFullAddress: {
      read: (existing, {
        readField
      }) => {
        const street1 = readField('street1');
        const street2 = readField('street2');
        const city = readField('city');
        const state = readField<Reference>('state');
        const abbrev = readField('abbreviation', state);
        const postalCode = readField('postalCode');

        return _.compact([
          street1,
          street2,
          city,
          abbrev,
          postalCode
        ]).join(', ');
      }
    }
  }
};



